import { useEffect, useRef, useState, useContext, React } from "react";
import Items from "./Items";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import MyContext from "../../../MyContext";
import brandImage from "../../../images/Anlook.svg";
import POSPayment from "./POS_Payment";
import POSOrderType from "./POS_OrderType";
import POSPrint from "./POS_Print";
import POSPrintKitchen from "./POS_Print_Kitchen";
import POSPrintKOT from "./POS_Print_KOT";
import PaymentScreen from "./POS_UPI_QR";
import "./Pos.css";
const ITEMS_PER_PAGE = 8;
const POS = ({ userID }) => {

  const debounceRef = useRef(null);
  const formRef = useRef();
  const barcodeInputRef = useRef(null);
  const itemSearchRef = useRef(null);
  const newmobileRef = useRef(null);

  const posRef = useRef(null);

  //Customer Details Important
  const [tabletMode, setTabletMode] = useState(false);

  const [mobile, setMobile] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [name, setName] = useState("");

  const [orderId, setOrderId] = useState("");
  const [orderType, setOrderType] = useState("");
  const [totalPrice, setTotalPrice] = useState(0.0);
  const [payAmountPrice, setayAmountPrice] = useState(0.0);
  const [dueAmount, setDueAmount] = useState(0.0);
  const [paidAmount, setPaidAmount] = useState(0.0);
  const [orderStatus, setOrderStatus] = useState("");
  const [kotEnabled, setKotEnabled] = useState("Y");
  const [selectedOptions, setSelectedOptions] = useState({});
  const [gstClaim, setGstClaim] = useState("N");
  const [sgst, setSgst] = useState("0.00");
  const [cgst, setCgst] = useState("0.00");



  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState("");
  const [customizationList, setCustomizationList] = useState([]);
  const [selectedCartItemIndex, setSelectedCartItemIndex] = useState(null);

  const [cancelOrderReason, setCancelOrderReason] = useState("");

  const [searchActive, setSearchActive] = useState(false);
  const [lastSearchTime, setLastSearchTime] = useState(null);
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [screen, setScreen] = useState("OrderType");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [itemPage, setItemPage] = useState(0);
  const [selectedCartItem, setSelectedCartItem] = useState({});
  const [cart, setCart] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [catalogueStore, setCatalogueStore] = useState([]);
  const [barcodeInput, setBarcodeInput] = useState("");
  const [barcodeResult, setBarcodeResult] = useState([]);

  const [selectedOrder, setSelectedOrder] = useState({});

  const [customerList, setCustomerList] = useState([]);
  const [tenderedAmount, setTenderedAmount] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  const [table, setTables] = useState([]);
  const [rooms, setRooms] = useState([]);

  const [selectedTable, setSelectedTable] = useState({});
  const [selectedRoom, setSelectedRoom] = useState({});
  const [organizationDetails, setOrganizationDetails] = useState("");
  const [reciptDetails, setreciptDetails] = useState({});
  const [orderOption, setOrderOption] = useState([]);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedPaymentFilter, setSelectedPaymentFilter] = useState("open");
  const [selectedOrderTypeFilter, setSelectedOrderTypeFilter] = useState("all");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showHoldModal, setShowHoldModal] = useState(false);
  const [showCustomizationModal, setShowCustomizationModal] = useState(false);
  const [activeInput, setActiveInput] = useState("barcode");
  const [editCustomer, setEditCustomer] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const writerRef = useRef(null);
  const [showUPIModal, setShowUPIModal] = useState(false);
  const [remarks, setRemarks] = useState("");


  const [posOrderLoader, setPosOrderLoader] = useState(false);
  const [searchCustomerLoader, setSearchCustomerLoader] = useState(false);
  const [holdOrderLoader, setHoldOrderLoader] = useState(false);
  const [KOTLoader, setKOTLoader] = useState(false);
  const [apiLoader, setAPiLoader] = useState(false);



  const [placeOrderLoader, setPlaceOrderLoader] = useState(false);
  const [otherPaymentMethodModal, setOtherPaymentMethodModal] = useState(false);
  const [assignToPackkyModal, setAssignToPackkyModal] = useState(false);
  const [deliveryPartner, setDeliveryPartner] = useState("");
  const [deliveryChargesDeductedFrom, setDeliveryChargesDeductedFrom] = useState("");


  const [printConfig, setPrintConfig] = useState({
    normalFontSize: "",
    largeFontSize: "",
    pageWidth: ""
  });


  const handleConnect = async () => {
    try {
      const port = await navigator.serial.requestPort();
      await port.open({ baudRate: 9600 });

      const encoder = new TextEncoderStream();
      encoder.readable.pipeTo(port.writable);
      const writer = encoder.writable.getWriter();
      writerRef.current = writer;

      setIsConnected(true);
      // localStorage.setItem('isConnected', 'true');
    } catch (err) {
      console.error("Connection failed:", err);
      setIsConnected(false);
      localStorage.removeItem("isConnected");
    }
  };

  const clearforcancelbutton = () => {
    setOrderId("");

  };

  useEffect(() => {
    const autoConnect = async () => {
      if (localStorage.getItem("isConnected") === "true") {
        try {
          const ports = await navigator.serial.getPorts();
          if (ports.length > 0) {
            const port = ports[0];
            await port.open({ baudRate: 9600 });

            const encoder = new TextEncoderStream();
            encoder.readable.pipeTo(port.writable);
            const writer = encoder.writable.getWriter();
            writerRef.current = writer;

            setIsConnected(true);
          } else {
            setIsConnected(false);
          }
        } catch (err) {
          console.error("Auto-connect failed:", err);
          setIsConnected(false);
          localStorage.removeItem("isConnected");
        }
      }
    };

    autoConnect();
  }, []);
  // Auto-reset page when cart changes
  useEffect(() => {
    setItemPage(0);
  }, [cart]);

  useEffect(() => {
    if (selectedOrder.totalOrderPrice > 0)
      setTotalPrice(selectedOrder.totalOrderPrice);
  }, [selectedOrder]);

  // Maintain focus on active input
  useEffect(() => {
    const interval = setInterval(() => {
      if (activeInput === "barcode") {
        if (document.activeElement !== barcodeInputRef.current) {
          barcodeInputRef.current?.focus();
        }
      } else if (activeInput === "search") {
        if (document.activeElement !== itemSearchRef.current) {
          itemSearchRef.current?.focus();
        }
      } else if (activeInput === "new_mobile") {
        if (document.activeElement !== newmobileRef.current) {
          newmobileRef.current?.focus();
        }
      }
    }, 200);

    return () => clearInterval(interval);
  }, [activeInput]);

  const allcatalogueAPI = async () => {
    setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        orderType: "ALL",
        platform: "pos",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCatalogItems`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setCatalogueStore(response.data.response);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    allcatalogueAPI();
  }, []);

  const PrintSeriveApiCall = async (OrderID) => {
    // setLoading(true);
    try {
      const requestBody = {
        userid: userID,
        orderId: OrderID
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/processPrint`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {

      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!barcodeInput || !catalogueStore.length) return;

    let foundItem = null;

    // Traverse each category
    for (const category of catalogueStore) {
      for (const item of category.menu_items || []) {
        if (item.item_id === barcodeInput) {
          foundItem = item;
          break;
        }
      }
      if (foundItem) break;
    }

    if (foundItem) {
      setBarcodeResult([foundItem]); // optional, if you want to store result

      // ✅ Use hardcoded selectedPrice for size_id 2
      const selectedPrice = {
        size_id: 2,
        price: 0, // Replace with default or actual price if needed
      };

      handleAddCart(foundItem, foundItem.prices[0]);
    }
  }, [barcodeInput, catalogueStore]);

  // Add item or increase quantity
  const handleAddCart = (item, selectedPrice) => {
    const itemKey = `${item.item_id}-${selectedPrice.size_id}`;

    const existingIndex = cart.findIndex(
      (i) => `${i.item_id}-${i.selectedPrice.size_id}` === itemKey
    );

    if (existingIndex !== -1) {
      const updatedCart = [...cart];
      updatedCart[existingIndex].quantity += 1;
      setCart(updatedCart);
    } else {
      setCart((prev) => [
        ...prev,
        { ...item, quantity: 1, selectedPrice: { ...selectedPrice } },
      ]);
    }

    setTotalPrice((prev) => Number(prev) + Number(selectedPrice.price));
    setBarcodeInput("");
    setBarcodeResult([]);
  };

  // Remove item or decrease quantity
  const handleRemoveCart = (item) => {
    const itemKey = `${item.item_id}-${item.selectedPrice.size_id}`;

    const itemIndex = cart.findIndex(
      (i) => `${i.item_id}-${i.selectedPrice.size_id}` === itemKey
    );

    if (itemIndex !== -1) {
      const updatedCart = [...cart];
      const cartItem = updatedCart[itemIndex];

      const quantity = cartItem.quantity;
      const printedQty = cartItem.kot_quantity_printed || 0;

      // Don't allow removing below the printed quantity
      if (quantity <= printedQty) {
        alert(
          `Cannot remove. ${printedQty} item(s) already printed in KOT.`
        );
        return;
      }

      //  Safe to reduce quantity
      if (quantity > 1) {
        cartItem.quantity -= 1;
      } else {
        updatedCart.splice(itemIndex, 1);
      }

      setCart(updatedCart);

      const priceToDeduct = Number(
        item.selectedPrice?.price || item.prices[0].price
      );
      setTotalPrice((prev) => Number(prev) - priceToDeduct);
    }
  };
  const clearCart = () => {
    // Keep only KOT-printed items
    const kotPrintedItems = cart.filter(item => item.kot_quantity_printed > 0);

    setCart(kotPrintedItems);

    // Recalculate total price only for remaining KOT items
    const newTotal = kotPrintedItems.reduce((sum, item) => {
      const price = item.selectedPrice?.price || item.prices[0].price;
      return sum + price * item.quantity;
    }, 0);

    setTotalPrice(newTotal);
    setSelectedDiscount(0);
  };

  const fetchCartData = async (orderId) => {
    const response = await axios.post(
      `${baseUrl}/api/Order/v1.0/getCartDetails`,
      { orderid: orderId },
      {
        headers: {
          Authorization: `Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  const enterFullscreen = () => {
    if (posRef.current.requestFullscreen) {
      posRef.current.requestFullscreen();
    } else if (posRef.current.webkitRequestFullscreen) {
      posRef.current.webkitRequestFullscreen();
    } else if (posRef.current.msRequestFullscreen) {
      posRef.current.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  const [apiResponsePrint, setApiResponsePrint] = useState({});



  const reciptDetailsApi = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
        userid: userID,
      }, config);

      if (response.data.responseCode === "00") {
        const receipt = response.data.response[0];
        setOrganizationDetails(response.data.response.logo);
        setPaymentMethods(response.data.paymentMethods);
        setreciptDetails(receipt);
        setGstClaim(response.data.response[0].gstClaim);
        setSgst(response.data.response[0].taxSgst);
        setCgst(response.data.response[0].taxCgst);
        setKotEnabled(response.data.response[0].kotEnabled);
        setDeliveryChargesDeductedFrom(response.data.response[0].chargesDeductedFrom)
        const parsedPrintSettings = JSON.parse(receipt.printSettings || "[]");

        const normalFontSize = parsedPrintSettings.find(s => s.key === "normalFontSize")?.value || "";
        const largeFontSize = parsedPrintSettings.find(s => s.key === "largeFontSize")?.value || "";
        const pageWidth = parsedPrintSettings.find(s => s.key === "pageWidth")?.value || "";

        setPrintConfig({
          normalFontSize,
          largeFontSize,
          pageWidth
        });
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };

  const customizationListApi = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrderCustomizations`,
        {
          userid: userID,
        },
        config
      );

      if (response.data.responseCode === "00") {
        setCustomizationList(response.data.response);
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };

  const OrderOptionsApi = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrderOptions`,
        {
          userid: userID,
        },
        config
      );

      if (response.data.responseCode === "00") {
        setOrderOption(response.data.response);
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };

  const cancelPOSOrderApi = async (orderId) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/cancelPosOrder`,
        {
          orderid: orderId,
          reason: cancelOrderReason,
          platform: "POS",
        },
        config
      );

      if (response.data.responseCode === "00") {
        getOrdersApi();
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };
  const getOrdersApi = async () => {
    const today = new Date().toISOString().split("T")[0]; // format: "YYYY-MM-DD"

    try {
      setPosOrderLoader(true);
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrders`,
        {
          userid: userID,
          secret: "string",
          fromdate: today,
          todate: today,
          status: ["hold", "completed", "open", "closed"],
        }, config
      );

      if (response.data.responseCode === "00") {
        setOrders(response.data.response);
        setFilteredOrders(response.data.response); // initially show all
      } else {
        console.error("Failed to fetch orders");
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setPosOrderLoader(false);
    }
  };
  const getCustomerApi = async () => {
    if (mobile.length < 10) {
      setCustomerList([]); // clear old results if input too short
      return;
    }

    try {
      setSearchCustomerLoader(true);
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getCustomerList`,
        {
          userid: userID,
          digit: mobile,
        },
        config
      );

      if (response.data.responseCode === "00") {
        setCustomerList(response.data.response);
        setSelectedCustomer(response.data.response[0]);
      } else {
        setCustomerList([]); // handle case with no records
        console.error("Failed to fetch customers");
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setSearchCustomerLoader(false);
    }
  };

  // 🔁 Debounced call when typing mobile
  useEffect(() => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      getCustomerApi();
    }, 400); // Debounce delay

    return () => clearTimeout(debounceRef.current);
  }, [mobile]);

  // ✅ Sync mobile field when user selects a customer
  useEffect(() => {
    if (selectedCustomer?.contact_number) {
      setMobile(selectedCustomer.contact_number);
    }
  }, [selectedCustomer?.id]);
  useEffect(() => {
    const filterData = () => {
      let filtered = orders;

      // Filter by payment status
      if (selectedPaymentFilter === "open") {
        filtered = filtered.filter((order) => order.status === "hold");
      } else if (
        selectedPaymentFilter === "paid" ||
        selectedPaymentFilter === "completed"
      ) {
        filtered = filtered.filter((order) => order.status === "completed");
      }

      // Filter by order type
      if (selectedOrderTypeFilter !== "all") {
        filtered = filtered.filter((order) => {
          const type = (order.orderType || "").toLowerCase().trim();

          if (selectedOrderTypeFilter === "takeaway") {
            return type === "takeaway" || type === "takeway";
          } else if (selectedOrderTypeFilter === "dining") {
            return type === "dining" || type === "dine-in";
          } else if (selectedOrderTypeFilter === "homedelivery") {
            return type === "homedelivery" || type === "home delivery";
          }
          return false;
        });
      }

      setFilteredOrders(filtered);
    };

    filterData();
  }, [orders, selectedPaymentFilter, selectedOrderTypeFilter]);

  const generateOrderIDApi = async (mobile, orderType) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/generateOrderNumber
`,
        {
          userid: userID,
          custMobile: mobile,
          orderType: orderType,
        },
        config
      );

      if (response.data.responseCode === "00") {
        setOrderId(response.data.data.orderId);
      } else {
        console.log("Order id not generated");
      }

      console.log(response);
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };

  const assignDeliveryPartnerApi = async (orderId) => {
    try {
      const payload = {
        userid: userID,
        orderId: orderId,
        platform: "pos",
        deliveryPartner: "packky",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/assignDeliveryPartner`,
        payload,
        config
      );
      if (response.data.responseCode === "00") {
      } else {
        console.log("Error");
      }
    } catch {
      console.log("Error");
    }
  };

  const applyCustomization = () => {
    if (selectedCartItemIndex === null) return;

    const updatedCart = [...cart];

    const customizations = Object.entries(selectedOptions).map(
      ([field, value]) => ({
        customization_type: "customize",
        customize_field: field,
        options: Array.isArray(value) ? value : [value],
      })
    );

    updatedCart[selectedCartItemIndex] = {
      ...updatedCart[selectedCartItemIndex],
      customizations, // <-- attach directly to item
    };

    setCart(updatedCart);
    setSelectedOptions({});
    setShowCustomizationModal(false);
  };

  const placeOrderApi = async (userID, cart, paymentMethod) => {
    try {
      setPlaceOrderLoader(true);
      setAPiLoader(true);
      const prepareOrderPayload = (userID, cart) => {
        const items = cart.map((item) => {
          const priceObj = item.prices[0];

          return {
            productId: item.item_id,
            sizeId: priceObj.size_id,
            productName: item.item_name,
            actualName: item.item_name,
            sizeWords: priceObj.size,
            quantity: item.quantity.toString(),
            itemPrice: priceObj.price,
            itemImage: item.photo,
            // customization: JSON.stringify(priceObj.customizations || []),
            customization: JSON.stringify(item.customizations || []),
            hasVarient: item.prices.length > 1 ? "true" : "false",
          };
        });

        return {
          userid: userID,
          currency: "INR",
          custMobile: mobile,
          custName: name,
          orderId: orderId,
          orderStatus: "completed",
          paymentMode: paymentMethod,
          receivedAmount: tenderedAmount,
          tableNo:
            orderType === "dining"
              ? selectedTable?.tableNo || selectedTable?.table_no || ""
              : orderType === "room_order"
                ? selectedRoom?.roomNumber || ""
                : "",



          items: items,
          deliveryChargesDeductedFrom: deliveryChargesDeductedFrom,
          deliveryPartner: deliveryPartner,

        };
      };

      const payload = prepareOrderPayload(userID, cart);

      const response = await axios.post(
        `${baseUrl}/api/Order/v2.0/placePosOrder`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        console.log("Order placed successfully:", response.data);
        setShowSuccessModal(true);
        const orderArr = response.data.response;
        setApiResponsePrint(response.data.response);
        const payAmt = Number(orderArr?.[0]?.pay_amount ?? 0);
        setayAmountPrice(payAmt);
        fetchTableApi();
        getOrdersApi();
        setSelectedOrder({});
        setAssignToPackkyModal(false);
        setDeliveryPartner("");
      }

    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setPlaceOrderLoader(false);
      setAPiLoader(false);
    }
  };
  const holdOrderApi = async (userID, cart) => {
    try {
      setHoldOrderLoader(true);
      setAPiLoader(true);

      const prepareOrderPayload = (userID, cart) => {
        const items = cart.map((item) => {
          const priceObj = item.prices[0];
          return {
            productId: item.item_id,
            sizeId: priceObj.size_id,
            productName: item.item_name,
            actualName: item.item_name,
            sizeWords: priceObj.size,
            quantity: item.quantity.toString(),
            itemPrice: priceObj.price,
            itemImage: item.photo,
            // customization: JSON.stringify(priceObj.customizations || []),
            customization: JSON.stringify(item.customizations || []),
            hasVarient: item.prices.length > 1 ? "true" : "false",
          };
        });
        return {
          userid: userID,
          currency: "INR",
          custMobile: mobile,
          custName: name || "",
          orderId: orderId,
          orderStatus: "hold",
          paymentMode: "unpaid",
          tableNo:
            orderType === "dining"
              ? selectedTable?.tableNo || selectedTable?.table_no || ""
              : orderType === "room_order"
                ? selectedRoom?.roomNumber || ""
                : "",
          items: items,
        };
      };
      const payload = prepareOrderPayload(userID, cart);
      const response = await axios.post(
        `${baseUrl}/api/Order/v2.0/placePosOrder`,
        payload,
        config
      );


      if (response.data.responseCode === "00") {
        //  setShowHoldModal(true);
        // setApiResponsePrint(response.data.response);
        console.log("Order placed successfully:", response.data);
        setCart([]);
        getOrdersApi();
        fetchTableApi();
        setScreen("OrderType");
        setSelectedOrder({});
      } else {
        console.error("Error placing order:");
      }
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setHoldOrderLoader(false);
      setAPiLoader(false);
    }
  };


  const holdOrderApiwithKOT = async (userID, cart) => {
    try {
      setKOTLoader(true);
      setAPiLoader(true);
      const prepareOrderPayload = (userID, cart) => {
        const items = cart.map((item) => {
          const priceObj = item.prices[0];
          return {
            productId: item.item_id,
            sizeId: priceObj.size_id,
            productName: item.item_name,
            actualName: item.item_name,
            sizeWords: priceObj.size,
            quantity: item.quantity.toString(),
            itemPrice: priceObj.price,
            itemImage: item.photo,
            // customization: JSON.stringify(priceObj.customizations || []),
            customization: JSON.stringify(item.customizations || []),
            hasVarient: item.prices.length > 1 ? "true" : "false",
          };
        });
        return {
          userid: userID,
          currency: "INR",
          custMobile: mobile,
          custName: name || "",
          orderId: orderId,
          orderStatus: "hold",
          paymentMode: "unpaid",
          tableNo:
            orderType === "dining"
              ? selectedTable?.tableNo || selectedTable?.table_no || ""
              : orderType === "room_order"
                ? selectedRoom?.roomNumber || ""
                : "",
          items: items,
        };
      };
      const payload = prepareOrderPayload(userID, cart);
      const response = await axios.post(
        `${baseUrl}/api/Order/v2.0/placePosOrder`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        const orderList = response.data.response;
        if (Array.isArray(orderList) && orderList.length > 0) {
          const placedOrderId = orderList[0].orderid;
          await KOTListAPI(placedOrderId);
          getOrdersApi();
          setSelectedOrder({});
        } else {
          console.error("No orders returned in hold order response");
        }
      }

    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setKOTLoader(false);
      setAPiLoader(false);
    }
  };

  // 🔄 Filters items that need KOT printing, but preserves full response object
  const filterKOTResponse = (response) => {
    if (!response || !response.items) return response;

    const filteredItems = response.items
      .filter((item) => {
        return item.fullPrinted === false && Number(item.kot_quatity) > 0;
      })
      .map((item) => {
        const remainingQty = Number(item.kot_quatity);
        return {
          ...item,
          quantity: remainingQty.toString(), // 👈 Fix applied here
          total_price: (remainingQty * parseFloat(item.item_price)).toFixed(2),
        };
      });

    return {
      ...response,
      items: filteredItems,
    };
  };

  const KOTListAPI = async (orderId) => {
    try {
      const payload = { orderId: orderId };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/printKot`,
        payload,
        config
      );

      if (response.data.responseCode === "00") {
        const fullOrder = response.data.response;
        const filteredOrder = filterKOTResponse(fullOrder);

        setShowHoldModal(true);
        setApiResponsePrint(filteredOrder); // used in modal
        setCart([]);
        getOrdersApi();
        fetchTableApi();
        setScreen("OrderType");
      } else {
        console.error("❌ KOT API non-00 response:", response.data);
      }
    } catch (error) {
      console.error("❌ KOT API error:", error);
    }
  };




  const holdOrderWithContinue = async (userID, cart) => {
    try {
      setAPiLoader(true);
      const prepareOrderPayload = (userID, cart) => {
        const items = cart.map((item) => {
          const priceObj = item.prices[0];
          return {
            productId: item.item_id,
            sizeId: priceObj.size_id,
            productName: item.item_name,
            actualName: item.item_name,
            sizeWords: priceObj.size,
            quantity: item.quantity.toString(),
            itemPrice: priceObj.price,
            itemImage: item.photo,
            customization: JSON.stringify(priceObj.customizations || []),
            hasVarient: item.prices.length > 1 ? "true" : "false",
          };
        });
        return {
          userid: userID,
          currency: "INR",
          custMobile: mobile,
          custName: name,
          orderId: orderId,
          orderStatus: "hold",
          paymentMode: "unpaid",
          tableNo:
            orderType === "dining"
              ? selectedTable?.tableNo || selectedTable?.table_no || ""
              : orderType === "room_order"
                ? selectedRoom?.roomNumber || ""
                : "",
          items: items,
        };
      };
      const payload = prepareOrderPayload(userID, cart);
      const response = await axios.post(
        `${baseUrl}/api/Order/v2.0/placePosOrder`,
        payload,
        config
      );
      console.log("Order placed successfully:", response.data);
      // setCart([]);
      getOrdersApi();
      fetchTableApi();
      setSelectedOrder({});
      setOtherPaymentMethodModal(false);

      // setScreen("OrderType");
      // return response.data;
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setAPiLoader(false);
    }
  };





  const fetchTableApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/getRestaurantTable`,
        requestBody,
        config
      );
      // Access the response correctly
      if (response.data.responseCode === "00") {
        setTables(response.data.response); // Correctly access the response data
        // toast.success(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching tables:", error); // Add error logging
      // toast.error("Failed to fetch tables.");
    }
  };

  const fetchRoomApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getRestaurantRooms`,
        requestBody,
        config
      );
      // Access the response correctly
      if (response.data.responseCode === "00") {
        setRooms(response.data.response); // Correctly access the response data
        // toast.success(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching tables:", error); // Add error logging
      // toast.error("Failed to fetch tables.");
    }
  };
  useEffect(() => {
    reciptDetailsApi();
    getOrdersApi();
    fetchTableApi();
    fetchRoomApi();
    OrderOptionsApi();
    customizationListApi();
  }, []);

  useEffect(() => {
    const baseAmount = Number(totalPrice) - Number(selectedDiscount);
    const newTenderedAmount = gstClaim === "Y" ? baseAmount * 1.05 : baseAmount;

    if (
      orderStatus === "partially_paid"
        ? setTenderedAmount(Number(dueAmount).toFixed(2))
        : setTenderedAmount(Number(newTenderedAmount.toFixed(2)))
    );
  }, [totalPrice, selectedDiscount, gstClaim, orderStatus]);


  const [enrichedTables, setEnrichedTables] = useState([]);
  function combineTablesWithHoldOrders(tables, orders) {
    const holdOrders = orders.filter(
      (order) => order.status === "hold" && order.table_no
    );

    const orderMap = {};
    holdOrders.forEach((order) => {
      orderMap[order.table_no] = order;
    });

    return tables.map((table) => ({
      ...table,
      attachedOrder: orderMap[table.tableNo] || null,
    }));
  }

  useEffect(() => {
    if (table && orders) {
      const combined = combineTablesWithHoldOrders(
        table,
        orders
      );
      setEnrichedTables(combined);
    }
  }, [table, orders]);

  const handlePrintNode = async (
    item,
    business_name,
    gst,
    address,
    phone_no,
    custfullAddress,
    normalFontSize,
    largeFontSize,
    pageWidth
  ) => {
    try {
      console.log("Sending order details:", JSON.stringify(item, null, 2));

      const cleanCustomerAddress = (custfullAddress ?? '').toString()
        .replace(/\s*\n\s*/g, ', ')
        .replace(/,\s*,+/g, ', ')
        .replace(/\s{2,}/g, ' ')
        .trim();



      const response = await fetch("http://localhost:3001/printReceipt", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          item,
          business_name,
          gst,
          address,
          phone_no,
          cleanCustomerAddress,
          printSettings: {
            normalFontSize,
            largeFontSize,
            pageWidth
          }
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
      } else {
        toast.error("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Direct print setup incomplete.");
    }
  };


  const printEachKOTItemSeparately = async (
    orderData,
    business_name,
    normalFontSize,
    largeFontSize,
    pageWidth
  ) => {
    if (!orderData?.items || !Array.isArray(orderData.items)) {
      toast.error("No items found in the order.");
      return;
    }

    for (const item of orderData.items) {
      const singleItemOrder = {
        ...orderData,
        items: [item] // only one item at a time
      };

      await handlePrintNodeKOT(
        singleItemOrder,
        business_name,
        normalFontSize,
        largeFontSize,
        pageWidth
      );
    }
  };


  const handlePrintNodeKOT = async (
    item,
    business_name,
    normalFontSize,
    largeFontSize,
    pageWidth
  ) => {
    try {
      console.log("Sending KOT details:", JSON.stringify(item, null, 2));

      const response = await fetch("http://localhost:3001/printKOT", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          item,
          business_name,
          printSettings: {
            normalFontSize,
            largeFontSize,
            pageWidth
          }
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "KOT printed successfully");
      } else {
        toast.error("Error: " + data.message);
      }
    } catch (error) {
      console.error("KOT Print Error:", error);
      toast.error("KOT printing failed.");
    }
  };

  return (
    <div
      ref={posRef}
      className={`position-relative ${tabletMode ? "tablet-mode" : ""}`}
    >
      <ToastContainer />

      {/* Watermark text */}
      <div className="pos-watermark">
        <div>Anlook POS</div>
      </div>

      <div className="pos-container d-flex flex-column vh-100">
        <div className="flex-grow-1 overflow-auto">
          {screen === "OrderType" && (
            <div className="row p-0 m-0 col-12 h-100">
              <POSOrderType
                tabletMode={tabletMode}
                orderId={orderId}
                setOrderId={setOrderId}
                setScreen={setScreen}
                mobile={mobile}
                setMobile={setMobile}
                setOrderType={setOrderType}
                orderType={orderType}
                generateOrderIDApi={generateOrderIDApi}
                orders={orders}
                filteredOrders={filteredOrders}
                selectedPaymentFilter={selectedPaymentFilter}
                setSelectedPaymentFilter={setSelectedPaymentFilter}
                selectedOrderTypeFilter={selectedOrderTypeFilter}
                setSelectedOrderTypeFilter={setSelectedOrderTypeFilter}
                customerList={customerList}
                setSelectedCustomer={setSelectedCustomer}
                selectedCustomer={selectedCustomer}
                setCart={setCart}
                table={table}
                setTables={setTables}
                selectedTable={selectedTable}
                setSelectedTable={setSelectedTable}
                setSelectedRoom={setSelectedRoom}
                selectedRoom={selectedRoom}
                setSelectedOrder={setSelectedOrder}
                selectedOrder={selectedOrder}
                userID={userID}
                setTotalPrice={setTotalPrice}
                setDueAmount={setDueAmount}
                setPaidAmount={setPaidAmount}
                setOrderStatus={setOrderStatus}
                setSelectedDiscount={setSelectedDiscount}
                catalogueStore={catalogueStore}
                getCustomerApi={getCustomerApi}
                fetchTableApi={fetchTableApi}
                reciptDetails={reciptDetails}
                editCustomer={editCustomer}
                setEditCustomer={setEditCustomer}
                setName={setName}
                gstClaim={gstClaim}
                sgst={sgst}
                cgst={cgst}
                rooms={rooms}
                orderOption={orderOption}
                cancelPOSOrderApi={cancelPOSOrderApi}
                setCancelOrderReason={setCancelOrderReason}
                cancelOrderReason={cancelOrderReason}
                setSelectedCartItem={setSelectedCartItem}
                enrichedTables={enrichedTables}
                posOrderLoader={posOrderLoader}
                searchCustomerLoader={searchCustomerLoader}
                getOrdersApi={getOrdersApi}
                totalPrice={totalPrice}
                printConfig={printConfig}
                apiLoader={apiLoader}
                setAssignToPackkyModal={setAssignToPackkyModal}
                setDeliveryPartner={setDeliveryPartner}

              />
            </div>
          )}

          {screen === "Catalog" && (
            <div className="row  p-0 m-0 h-100">
              <div
                className="col-3  p-2 m-0 h-100 d-flex flex-column "
                style={{ height: "100%" }}
              >


                <div className={tabletMode ? "" : "d-flex flex-column h-100"}>
                  {/* Header */}
                  <div className="mb-2">
                    <input
                      type="text"
                      placeholder="Scan or search by item ID"
                      // ref={barcodeInputRef}
                      value={barcodeInput}
                      onChange={(e) => setBarcodeInput(e.target.value)}
                      className="w-100 border border-dark p-2 rounded"
                      onFocus={() => setActiveInput("barcode")}
                    // autoFocus
                    />
                  </div>

                  {/* Scrollable Cart Content */}
                  <div
                    className="flex-grow-1 overflow-auto"
                    style={{
                      maxHeight: "calc(100vh - 200px)",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {cart.length > 0 ? (
                      <table className={tabletMode ? "tablet-font-1" : "align-middle m-0 w-100"}>
                        <thead className="table-light">
                          <tr>
                            <th className="p-2 bg-light">Item</th>
                            <th className="text-center p-2 bg-light">Qty</th>
                            <th className="p-2 bg-light">Price</th>
                            <th className="text-center p-2 bg-light">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cart.map((item, index) => {
                            const isSelected = selectedCartItem.item_name === item.item_name;
                            const isKOTLocked = item.quantity === item.kot_quantity_printed;

                            return (
                              <tr
                                key={index}
                                className={`${isSelected ? "bg-warning" : ""}`}
                                style={{
                                  borderBottom: "1px solid #ccc",
                                  backgroundColor: isKOTLocked ? "#fff6e5" : "white", // soft orange for KOT
                                  transition: "background 0.3s",
                                }}
                              >
                                <td
                                  className="fw-bold text-dark cursor-pointer p-3 position-relative"
                                  onClick={() => {
                                    setSelectedCartItem(item);
                                    setSelectedCartItemIndex(index);
                                  }}
                                >
                                  <div className="d-flex flex-column">
                                    <span>
                                      {item.item_name}{" "}
                                      {item.selectedPrice?.size ? `(${item.selectedPrice.size})` : ""}
                                    </span>

                                    {item.customizations?.length > 0 && (
                                      <div
                                        className="text-muted fw-normal"
                                        style={{ fontSize: "0.85rem", marginTop: "2px" }}
                                      >
                                        {item.customizations
                                          .flatMap((custom) =>
                                            Array.isArray(custom.options) ? custom.options : [custom.options]
                                          )
                                          .join(", ")}
                                      </div>
                                    )}

                                    {isKOTLocked && (
                                      <span
                                        className="badge text-dark mt-1"
                                        style={{
                                          backgroundColor: "#ffbf00",
                                          fontSize: "0.75rem",
                                          alignSelf: "flex-start",
                                          padding: "4px 8px",
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        KOT Printed
                                      </span>
                                    )}
                                  </div>
                                </td>

                                <td
                                  className="text-center fw-bold cursor-pointer p-3"
                                  onClick={() => {
                                    setSelectedCartItem(item);
                                    setSelectedCartItemIndex(index);
                                  }}
                                >
                                  {item.quantity}
                                </td>

                                <td
                                  className="fw-bold text-dark p-3 cursor-pointer"
                                  onClick={() => {
                                    setSelectedCartItem(item);
                                    setSelectedCartItemIndex(index);
                                  }}
                                >
                                  ₹{item.prices[0].price * item.quantity}
                                </td>

                                <td className="text-center p-2 align-middle">
                                  <div className="btn-group" role="group">
                                    <button
                                      className={tabletMode ? "btn btn-outline-danger   px-2" : "btn btn-outline-danger fw-bold fs-4 px-3"}
                                      onClick={() => handleRemoveCart(item, item.selectedPrice)}
                                      disabled={isKOTLocked}
                                      style={{
                                        opacity: isKOTLocked ? 0.5 : 1,
                                        cursor: isKOTLocked ? "not-allowed" : "pointer",
                                      }}
                                    >
                                      −
                                    </button>
                                    <button
                                      className={tabletMode ? "btn btn-outline-success  px-2" : "btn btn-outline-success fw-bold fs-4 px-3"}
                                      onClick={() => handleAddCart(item, item.selectedPrice)}
                                    >
                                      +
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}


                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center py-4 text-muted">
                        Cart is empty
                      </div>
                    )}
                  </div>
                  {/* {JSON.stringify(cart)} */}

                  <div className="border-top  py-2 pt-4">
                    <h4 className="m-0 fw-bold text-dark text-center">
                      <div className="d-flex justify-content-between">
                        <div>Total</div> <div> ₹ {totalPrice || "0.00"}</div>
                      </div>{" "}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-9 p-0 m-0 h-100 ">
                <Items
                  tabletMode={tabletMode}
                  userID={userID}
                  mobile={mobile}
                  handleAddCart={handleAddCart}
                  catalogueStore={catalogueStore}
                  setCatalogueStore={setCatalogueStore}
                  itemSearchRef={itemSearchRef}
                  newmobileRef={newmobileRef}
                  onFocus={() => setActiveInput("search")}
                  onFocusMobile={() => setActiveInput("new_mobile")}

                  getCustomerApi={getCustomerApi}
                  customerList={customerList}
                  selectedCustomer={selectedCustomer}
                  orderType={orderType}
                  editCustomer={editCustomer}
                  setEditCustomer={setEditCustomer}
                  gstClaim={gstClaim}
                  sgst={sgst}
                  cgst={cgst}
                  setSelectedCustomer={setSelectedCustomer}
                  searchCustomerLoader={searchCustomerLoader}

                  setMobile={setMobile}
                  orderId={orderId}
                />
              </div>
            </div>
          )}
          {screen === "Payment" && (
            <div className="row p-0 m-0 col-12 h-100">
              <POSPayment

                cart={cart}
                totalPrice={totalPrice}
                reciptDetails={reciptDetails}
                tenderedAmount={tenderedAmount}
                setTenderedAmount={setTenderedAmount}
                dueAmount={dueAmount}
                paidAmount={paidAmount}
                placeOrderApi={placeOrderApi}
                userID={userID}
                setScreen={setScreen}
                orderType={orderType}
                orderStatus={orderStatus}
                selectedDiscount={selectedDiscount}
                setSelectedDiscount={setSelectedDiscount}
                orderId={orderId}
                setShowUPIModal={setShowUPIModal}
                gstClaim={gstClaim}
                sgst={sgst}
                cgst={cgst}
                paymentMethods={paymentMethods}
                selectedPaymentMethods={selectedPaymentMethods}
                setSelectedPaymentMethods={setSelectedPaymentMethods}
                setRemarks={setRemarks}
                remarks={remarks}
                placeOrderLoader={placeOrderLoader}
                setOtherPaymentMethodModal={setOtherPaymentMethodModal}
                otherPaymentMethodModal={otherPaymentMethodModal}
                setAssignToPackkyModal={setAssignToPackkyModal}
                assignToPackkyModal={assignToPackkyModal}
                setDeliveryChargesDeductedFrom={setDeliveryChargesDeductedFrom}
                deliveryChargesDeductedFrom={deliveryChargesDeductedFrom}
                setDeliveryPartner={setDeliveryPartner}
                deliveryPartner={deliveryPartner}
                apiLoader={apiLoader}
              />
            </div>
          )}
        </div>

        {/* Sticky Footer */}
        <div
          className="bg-light border-top px-2 py-2 d-flex justify-content-between align-items-center"
          style={{ height: "80px" }}
        >
          <div className="row col-12 m-0 p-0 d-flex justify-content-between align-items-center">
            <div className="col-3 m-0 p-0 text-center ">
              {screen === "Catalog" ? (
                <div className="w-100">
                  <button
                    className="scale-button  btn btn-success bg-green-order fw-bold fs-4 w-100"
                    disabled={cart.length < 1}
                    onClick={() => {
                      setScreen("Payment");
                      holdOrderWithContinue(userID, cart);
                    }}
                    style={{ height: "60px" }}
                  >
                    Payment
                  </button>
                </div>
              ) : (
                <div className="d-flex justify-content-start">
                  {!isFullscreen ? (
                    <button
                      className="scale-button btn btn-outline-secondary"
                      onClick={enterFullscreen}
                    >
                      Fullscreen
                    </button>
                  ) : (
                    <button
                      className="btn btn-outline-dark"
                      onClick={exitFullscreen}
                    >
                      Exit Fullscreen
                    </button>
                  )}
                  {/* <div>
  <button
    className="btn btn-outline-dark single-line-css ms-4"
    onClick={() => setTabletMode((prev) => !prev)}
  >
    {tabletMode ? "Off Tablet Mode" : "On Tablet Mode"}
  </button>
</div> */}
                </div>
              )}

            </div>

            <div className="col-7 p-0 m-0">
              {screen !== "OrderType" && (
                <div className="row g-2 align-items-center d-flex justify-content-center">
                  {/* Cancel / Back Button */}
                  <div className="col-2">
                    {screen === "Catalog" ? (
                      <button
                        // disabled
                        className="scale-button  btn btn-secondary fs-4 fw-semibold w-100 text-white"
                        onClick={() => setEditCustomer(true)}
                        style={{ height: "60px" }}
                      >
                        Customer
                      </button>
                    ) : (
                      // <button
                      //   className="btn btn-secondary fs-5 fw-semibold w-100"
                      //   onClick={() => setScreen("Catalog")}
                      //   style={{ height: "60px" }}
                      // >
                      //   Back
                      // </button>
                      <></>
                    )}
                  </div>

                  {/* Hold and Clear - only on Catalog/Review */}
                  {["Catalog", "Review"].includes(screen) && (
                    <>
                      <div className="col-2">
                        <button
                          className="scale-button  btn btn-danger fw-semibold fs-4 w-100"
                          onClick={() => clearCart()}
                          style={{ height: "60px" }}
                        >
                          Clear
                        </button>
                      </div>
                      <div className="col-2">
                        <button
                          className="scale-button btn btn-info text-white fw-semibold fs-4 w-100"
                          disabled={
                            !selectedCartItem || !selectedCartItem.item_name
                          }
                          onClick={() => setShowCustomizationModal(true)}
                          style={{ height: "60px" }}
                        >
                          Customize
                        </button>
                      </div>
                      <div className="col-2">
                        <button
                          className="scale-button btn btn-warning fw-semibold fs-4 w-100"
                          disabled={cart.length < 1}
                          onClick={() => holdOrderApi(userID, cart)}
                          style={{ height: "60px" }}
                        >
                          {!holdOrderLoader ? "Hold" : "Holding.."}
                        </button>
                      </div>
                      <div className="col-2">
                        <button
                          className="scale-button btn btn-primary fw-semibold fs-4 w-100"
                          disabled={cart.length < 1 || userID === "A1021"}
                          onClick={() => holdOrderApiwithKOT(userID, cart)}
                          style={{ height: "60px" }}
                        >
                          {!KOTLoader ? "KOT" : "Generating..."}
                        </button>
                      </div>
                    </>
                  )}



                  {/* Place Order Button - Payment only */}
                  {screen === "Payment" && <></>}
                </div>
              )}
            </div>
            <div className="col-2 d-flex justify-content-center align-items-center gap-2">
              {screen === "Catalog" ? (
                <button
                  className="scale-button btn btn-dark fs-4 fw-semibold w-100"
                  onClick={() => { setScreen("OrderType"); clearforcancelbutton() }}
                  style={{ height: "60px" }}
                >
                  Cancel
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        {showSuccessModal && (
          <>
            {/* Backdrop */}
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
              style={{ zIndex: 1040 }}
              onClick={() => {
                setShowSuccessModal(false);
                setCart([]);
                getOrdersApi();
                setTenderedAmount("");
                setScreen("OrderType");
              }}
            />

            {/* Modal */}
            <div
              className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow"
              style={{ width: "1000px", zIndex: 1050 }}
            >
              <div className="row col-12 m-0 p-0">
                <div className="col-8 p-4 bg-white rounded shadow-sm border">
                  {/* {JSON.stringify(apiResponsePrint)} */}
                  {/* Success Tick and Title */}
                  <div className="mb-5 text-center">
                    <div
                      className="bg-success rounded-circle d-inline-flex align-items-center justify-content-center shadow"
                      style={{ width: "100px", height: "100px" }}
                    >
                      <span
                        className="text-white fw-bold"
                        style={{ fontSize: "60px" }}
                      >
                        ✓
                      </span>
                    </div>
                    <h1 className="mt-4 text-success fw-bold">Order Placed</h1>
                    <h4 className="text-dark">Successfully</h4>
                  </div>

                  {/* Customer Details */}
                  <div className="mb-4 px-2 fs-5 text-start">
                    <p>
                      <strong className="text-dark">Customer Mobile :</strong>{" "}
                      <span className="text-secondary">{mobile}</span>
                    </p>
                    <p>
                      <strong className="text-dark">Order Type :</strong>{" "}
                      <span className="text-secondary">{orderType}</span>
                    </p>
                  </div>

                  {/* Cart Items Table */}
                  <div className="table-responsive mb-5">
                    <table className="table table-bordered text-center align-middle shadow-sm">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>Unit Price (₹)</th>
                          <th>Total (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cart.map((item, index) => {
                          const price = parseFloat(item.prices[0].price);
                          const total = price * item.quantity;

                          return (
                            <tr key={item.item_id}>
                              <td>{index + 1}</td>
                              <td className="text-start">{item.item_name}</td>
                              <td>{item.quantity}</td>
                              <td>₹{price.toFixed(2)}</td>
                              <td>₹{total.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Price Summary */}
                  <div className="bg-light p-3 rounded shadow-sm">
                    <div className="d-flex justify-content-between fs-5 mb-2">
                      <span className="fw-semibold">Subtotal:</span>
                      <span className="text-muted">₹{totalPrice}</span>
                    </div>
                    <div className="d-flex justify-content-between fs-5 mb-2">
                      <span className="fw-semibold">Discount Amount:</span>
                      <span className="text-muted">₹{selectedDiscount}</span>
                    </div>

                    {gstClaim === "Y" && (
                      <>
                        {/* GST Breakdown */}
                        <div className="d-flex justify-content-between fs-5 mb-2">
                          <span className="fw-semibold">CGST (2.5%):</span>
                          <span className="text-muted">
                            ₹
                            {((totalPrice - selectedDiscount) * 0.025).toFixed(
                              2
                            )}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between fs-5 mb-2">
                          <span className="fw-semibold">SGST (2.5%):</span>
                          <span className="text-muted">
                            ₹
                            {((totalPrice - selectedDiscount) * 0.025).toFixed(
                              2
                            )}
                          </span>
                        </div>
                      </>
                    )}

                    <hr />
                    <div className="d-flex justify-content-between fw-bold fs-4 text-success">
                      <span>Total:</span>
                      <span>
                        ₹
                        {
                          gstClaim === "Y"
                            ? ((totalPrice - selectedDiscount) * 1.05).toFixed(
                              2
                            ) // With GST
                            : (totalPrice - selectedDiscount).toFixed(2) // Without GST
                        }
                      </span>
                    </div>
                    <div className="d-flex justify-content-between fw-bold fs-4 text-primary">
                      <span>Pay Amount:</span>
                      <span>
                        ₹
                        {(
                          Number(payAmountPrice) > 0
                            ? Number(payAmountPrice) // ✅ backend pay_amount
                            : gstClaim === "Y"
                              ? (Number(totalPrice) - Number(selectedDiscount)) * 1.05
                              : (Number(totalPrice) - Number(selectedDiscount))
                        ).toFixed(2)}
                      </span>
                    </div>

                  </div>
                </div>

                <div
                  style={{ borderLeft: "3px dashed #000" }}
                  className="col-4 p-2 d-flex flex-column justify-content-center align-items-center"
                >
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="w-100">
                      <button
                        type="button"
                        // disabled={selectedOrder.status !== "hold"}
                        onClick={() =>
                          handlePrintNode(
                            apiResponsePrint[0],
                            reciptDetails.business_name,
                            reciptDetails.gst,
                            reciptDetails.address,
                            reciptDetails.phone_no,
                            // fullAddress,
                            apiResponsePrint[0].address_line,
                            printConfig.normalFontSize,
                            printConfig.largeFontSize,
                            printConfig.pageWidth
                          )
                        }

                        style={{ height: "120px", width: "250px" }}
                        className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-4 fw-bold"
                      >
                        DIRECT PRINT
                      </button>
                    </div>
                    <div className="p-2">
                      {/* <button
                        onClick={() => PrintSeriveApiCall(orderId)}
                        style={{ height: "120px", width: "250px" }}
                        className={
                          tabletMode
                            ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                            : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                        }
                      >
                        PRINT
                      </button> */}
                      <POSPrint
                        cart={cart}
                        reciptDetails={reciptDetails}
                        totalPrice={totalPrice}
                        mobile={mobile}
                        orderType={orderType}
                        orderId={orderId}
                        tenderedAmount={tenderedAmount}
                        selectedDiscount={selectedDiscount}
                        apiResponsePrint={apiResponsePrint}
                        gstClaim={gstClaim}
                        sgst={sgst}
                        cgst={cgst}
                      />
                    </div>
                    <div className="p-2">
                      <POSPrintKitchen
                        cart={cart}
                        reciptDetails={reciptDetails}
                        totalPrice={totalPrice}
                        mobile={mobile}
                        orderType={orderType}
                        orderId={orderId}
                        tenderedAmount={tenderedAmount}
                        selectedDiscount={selectedDiscount}
                        apiResponsePrint={apiResponsePrint}
                        gstClaim={gstClaim}
                        sgst={sgst}
                        cgst={cgst}
                      />
                    </div>
                    {/* {orderType === "homedelivery" && (
                      <>
                      
                        <div className="p-2">
                          <button
                            onClick={() => {
                              assignDeliveryPartnerApi(orderId);
                            
                            }}
                            style={{ height: "120px", width: "250px" }}
                            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-4 fw-bold"
                          >
                            ASSIGN TO PACKKY
                          </button>
                        </div>
                      </>
                    )} */}

                    <div className="p-2">
                      <button
                        onClick={() => {
                          setShowSuccessModal(false);
                          setCart([]);
                          getOrdersApi();
                          setTenderedAmount("");
                          setScreen("OrderType");
                        }}
                        style={{ height: "120px", width: "250px" }}
                        className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-4 fw-bold"
                      >
                        HOME
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {showHoldModal && (
          <>
            {/* Backdrop */}
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
              style={{ zIndex: 1040 }}
              onClick={() => {
                setShowHoldModal(false);
                setCart([]);
                getOrdersApi();
                setTenderedAmount("");
                setScreen("OrderType");
              }}
            />

            {/* Modal */}
            <div
              className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow border border-warning"
              style={{ width: "1000px", zIndex: 1050 }}
            >
              <div className="row col-12 m-0 p-0">
                <div className="col-8 p-4 bg-warning bg-opacity-10 rounded shadow-sm border border-warning">
                  {/* {JSON.stringify(apiResponsePrint)} */}
                  {/* Success Tick and Title */}
                  <div className="mb-5 text-center">
                    <div
                      className="bg-warning rounded-circle d-inline-flex align-items-center justify-content-center shadow"
                      style={{ width: "100px", height: "100px" }}
                    >
                      <span
                        className="text-white fw-bold"
                        style={{ fontSize: "60px" }}
                      >
                        ✓
                      </span>




                    </div>
                    <h1 className="mt-4 text-warning fw-bold">KOT Generated</h1>
                  </div>

                  {/* Customer Details */}
                  <div className="mb-4 px-2 fs-5 text-start">
                    <p>
                      <strong className="text-dark">Customer Mobile :</strong>{" "}
                      <span className="text-secondary">{mobile}</span>
                    </p>
                    <p>
                      <strong className="text-dark">Order Type :</strong>{" "}
                      <span className="text-secondary">{orderType}</span>
                    </p>
                  </div>

                  {/* Cart Items Table (from API Response) */}
                  <div className="table-responsive mb-5">
                    <table className="table table-bordered text-center align-middle shadow-sm">
                      <thead className="table-warning">
                        <tr>
                          <th>#</th>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>Unit Price (₹)</th>
                          <th>Total (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {apiResponsePrint?.items?.map((item, index) => {
                          const price = parseFloat(item.item_price);
                          const total = parseFloat(item.total_price);

                          return (
                            <tr key={item.item_id}>
                              <td>{index + 1}</td>
                              <td className="text-start">{item.item_name}</td>
                              <td>{item.quantity}</td>
                              <td>₹{price.toFixed(2)}</td>
                              <td>₹{total.toFixed(2)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Price Summary */}
                  <div className="bg-light p-3 rounded shadow-sm border border-warning">
                    <div className="d-flex justify-content-between fs-5 mb-2">
                      <span className="fw-semibold">Subtotal:</span>
                      <span className="text-muted">₹{totalPrice}</span>
                    </div>
                    <div className="d-flex justify-content-between fs-5 mb-2">
                      <span className="fw-semibold">Discount Amount:</span>
                      <span className="text-muted">₹{selectedDiscount}</span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between fw-bold fs-4 text-success">
                      <span>Total:</span>
                      <span>
                        ₹{Number(totalPrice) - Number(selectedDiscount)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right-side Buttons and Print */}
                <div
                  style={{ borderLeft: "3px dashed #000" }}
                  className="col-4 p-2 d-flex flex-column justify-content-center align-items-center"
                >
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="w-100">
                      <button
                        type="button"
                        onClick={() =>
                          handlePrintNodeKOT(
                            apiResponsePrint,
                            reciptDetails.business_name,
                            printConfig.normalFontSize,
                            printConfig.largeFontSize,
                            printConfig.pageWidth
                          )
                        }

                        style={{ height: "120px", width: "250px" }}
                        className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-4 fw-bold"
                      >
                        DIRECT PRINT KOT
                      </button>
                    </div>
                    <div className="p-2">
                      <POSPrintKOT
                        cart={cart}
                        reciptDetails={reciptDetails}
                        totalPrice={totalPrice}
                        mobile={mobile}
                        orderType={orderType}
                        orderId={orderId}
                        tenderedAmount={tenderedAmount}
                        selectedDiscount={selectedDiscount}
                        apiResponsePrint={apiResponsePrint}
                        gstClaim={gstClaim}
                        sgst={sgst}
                        cgst={cgst}
                      />
                    </div>
                    <div className="p-2">
                      <button
                        onClick={() => {
                          setShowHoldModal(false);
                          setCart([]);
                          getOrdersApi();
                          setTenderedAmount("");
                          setScreen("OrderType");
                        }}
                        style={{ height: "120px", width: "250px" }}
                        className="scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                      >
                        HOME
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {showUPIModal && (
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow"
            style={{ width: "1000px", zIndex: 1050 }}
          >
            <div className="row col-12 m-0 p-0">
              <PaymentScreen
                tenderedAmount={tenderedAmount}
                orderId={orderId}
                userID={userID}
                custName="Radha krishna"
                custMobile="7524807719"
                setShowUPIModal={setShowUPIModal}
                isConnected={isConnected}
                onConnect={handleConnect}
                writerRef={writerRef}
                gstClaim={gstClaim}
                sgst={sgst}
                cgst={cgst}
                cart={cart}


                reciptDetails={reciptDetails}

                placeOrderApi={placeOrderApi}
                setScreen={setScreen}


                selectedPaymentMethods={selectedPaymentMethods}
                placeOrderLoader={placeOrderLoader}
                apiLoader={apiLoader}





              />
            </div>
          </div>
        )}

        {showCustomizationModal && (
          <>
            {/* Backdrop */}
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
              style={{ zIndex: 1040 }}
              onClick={() => {
                setShowCustomizationModal(false);
                setSelectedOptions([]);
              }}
            />

            {/* Modal */}
            <div
              className="position-fixed top-50 start-50 translate-middle bg-white p-4 rounded-4 shadow border border-warning"
              style={{ width: "1000px", zIndex: 1050 }}
            >
              <div className="row col-12 m-0 p-0">
                {/* Left: Customizations */}
                <div
                  className="col-8 p-4 bg-warning bg-opacity-10 rounded shadow-sm border border-warning"
                  style={{ maxHeight: "80vh", overflowY: "auto" }}
                >
                  <div className="mb-4 text-center">
                    <h2 className="text-warning fw-bold mb-1">Customize</h2>
                    <h4 className="text-dark">{selectedCartItem.item_name}</h4>
                  </div>

                  <div className="text-start">
                    {/* Customize (Radio) */}
                    <div className="mb-4">
                      <label className="fw-bold fs-5">Choose One:</label>
                      <div className="d-flex flex-wrap gap-3 mt-3">
                        {customizationList
                          .filter((c) => c.customization_type === "customize")
                          .map((item) => (
                            <button
                              key={item.id}
                              className={`btn px-4 py-3 fs-5 fw-bold border rounded-3 ${selectedOptions?.customize ===
                                item.customization
                                ? "btn-warning text-dark border-dark"
                                : "btn-outline-dark"
                                }`}
                              onClick={() =>
                                setSelectedOptions((prev) => ({
                                  ...prev,
                                  customize: item.customization,
                                }))
                              }
                            >
                              {item.customization}
                            </button>
                          ))}
                      </div>
                    </div>

                    {/* Add-ons (Checkboxes) */}
                    <div className="mb-4">
                      <label className="fw-bold fs-5">Add-ons:</label>
                      <div className="d-flex flex-wrap gap-3 mt-3">
                        {customizationList
                          .filter((c) => c.customization_type === "add-ons")
                          .map((item) => {
                            const selected = selectedOptions?.addons?.includes(
                              item.customization
                            );
                            return (
                              <button
                                key={item.id}
                                className={`btn px-4 py-3 fs-5 fw-bold border rounded-3 ${selected
                                  ? "btn-success border-dark"
                                  : "btn-outline-dark"
                                  }`}
                                onClick={() => {
                                  setSelectedOptions((prev) => {
                                    const current = prev.addons || [];
                                    const exists = current.includes(
                                      item.customization
                                    );
                                    return {
                                      ...prev,
                                      addons: exists
                                        ? current.filter(
                                          (a) => a !== item.customization
                                        )
                                        : [...current, item.customization],
                                    };
                                  });
                                }}
                              >
                                {item.customization}
                              </button>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Right: Action Buttons */}
                <div
                  style={{ borderLeft: "3px dashed #000" }}
                  className="col-4 p-4 d-flex flex-column justify-content-between align-items-center"
                >
                  <div className="w-100">
                    <button
                      onClick={applyCustomization}
                      className="scale-button w-100 py-4 mb-4 fs-4 fw-bold btn btn-warning rounded shadow"
                    >
                      APPLY & CLOSE
                    </button>
                    <button
                      onClick={() => {
                        setShowCustomizationModal(false);
                        setSelectedOptions([]);
                      }}
                      className="scale-button w-100 py-4 fs-4 fw-bold btn btn-outline-dark rounded shadow"
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default POS;
